import { GitHubSocialLogo, TgSocialLogo } from "src/components";

export const CURRENT_YEAR = new Date().getFullYear();

export const SOCIAL_LINKS = [
  {
    id: "telegram",
    label: "Telegram",
    href: "https://t.me/PoizonAPI",
    Icon: TgSocialLogo,
  },
  {
    id: "github",
    label: "GitHub",
    href: "https://github.com/Poizon-API",
    Icon: GitHubSocialLogo,
  },
];
